// Input: teclado + mouse (pointer lock). Yaw/pitch aplicados NA HORA (rAF) para
// zero lag de mira; o InputCmd do tick captura os ângulos correntes.
import { M_YAW, M_PITCH, PITCH_CLAMP } from '@surfrun/shared';
import type { InputCmd } from '../physics/move';

export class Input {
  yaw = 0;   // graus
  pitch = 0;
  sensitivity = 1.2; // escala do CS (settings na F6)

  private keys = new Set<string>();
  private el: HTMLElement;
  onLockChange: ((locked: boolean) => void) | null = null;
  onKeyDown: ((code: string) => void) | null = null;

  constructor(el: HTMLElement) {
    this.el = el;
    window.addEventListener('keydown', (e) => {
      if (e.code === 'Tab' || e.code === 'F3') e.preventDefault();
      if (!e.repeat) {
        this.keys.add(e.code);
        this.onKeyDown?.(e.code);
      }
    });
    window.addEventListener('keyup', (e) => this.keys.delete(e.code));
    window.addEventListener('blur', () => this.keys.clear());

    window.addEventListener('mousemove', (e) => {
      if (!this.locked) return;
      this.yaw -= e.movementX * this.sensitivity * M_YAW;
      this.pitch -= e.movementY * this.sensitivity * M_PITCH;
      if (this.pitch > PITCH_CLAMP) this.pitch = PITCH_CLAMP;
      if (this.pitch < -PITCH_CLAMP) this.pitch = -PITCH_CLAMP;
      this.yaw = ((this.yaw % 360) + 360) % 360;
    });

    document.addEventListener('pointerlockchange', () => {
      this.onLockChange?.(this.locked);
      if (!this.locked) this.keys.clear();
    });
  }

  get locked(): boolean { return document.pointerLockElement === this.el; }

  requestLock(): void {
    // unadjustedMovement: mouse RAW, sem aceleração do SO — essencial pro feel de CS.
    // Alguns browsers não suportam a opção; cai no lock padrão.
    const p = (this.el as HTMLElement & {
      requestPointerLock: (o?: { unadjustedMovement?: boolean }) => Promise<void> | void;
    }).requestPointerLock({ unadjustedMovement: true });
    if (p && typeof (p as Promise<void>).catch === 'function') {
      (p as Promise<void>).catch(() => this.el.requestPointerLock());
    }
  }

  down(code: string): boolean { return this.keys.has(code); }

  /** Amostra o comando do tick atual. */
  sample(out: InputCmd): InputCmd {
    out.fwd = (this.down('KeyW') ? 1 : 0) + (this.down('KeyS') ? -1 : 0);
    out.side = (this.down('KeyD') ? 1 : 0) + (this.down('KeyA') ? -1 : 0);
    out.jump = this.down('Space');
    out.duck = this.down('ShiftLeft') || this.down('ControlLeft');
    out.yaw = this.yaw;
    out.pitch = this.pitch;
    return out;
  }
}
